import { useEffect, useState } from 'react';
import { usePoseWorkerStore } from '../../../zustand/pose-worker-store';

// The remote pose service answers every processed frame (10-15 a second). This long without one, the
// link is down (room reconnecting or moving, the pod gone), and any pose the page still holds is stale.
export const POSE_STALE_MS = 2000;
const POLL_MS = 500;

/** Whether a remote runtime's `status()` says its results stopped; false before the first one. */
export function poseLinkDown(status, nowMs) {
  return Boolean(status?.results) && nowMs - status.lastResultAt > POSE_STALE_MS;
}

/**
 * The remote pose link is down: the page pauses the exercise (no frames, clocks held) until results flow
 * again, rather than scoring a frozen pose. Local MediaPipe runtimes have no link.
 */
export default function usePoseLinkDown({ enabled }) {
  const runtime = usePoseWorkerStore(state => state.runtime);
  const [down, setDown] = useState(false);

  useEffect(() => {
    if (!enabled || runtime?.kind !== 'remote' || typeof runtime.status !== 'function') {
      setDown(false);
      return undefined;
    }
    const intervalId = window.setInterval(
      () => setDown(poseLinkDown(runtime.status(), performance.now())),
      POLL_MS
    );
    return () => window.clearInterval(intervalId);
  }, [enabled, runtime]);

  return down;
}
